"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityListRouteComponent = exports.EntityListRoute = exports.EntityListRouteComponent = exports.EntityListRouteDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_list_layout_1 = require("./entity-list-layout");
var seo_1 = require("../elements/seo");
var current_user_can_1 = require("../../utils/current-user-can");
var use_lang_1 = require("../../hooks/use-lang");
var app_screen_layout_1 = require("../app/app-screen-layout");
var entity_list_tabs_1 = require("./entity-list-tabs");
var entity_network_layout_1 = require("./entity-network-layout");
var lodash_1 = require("lodash");
var entity_map_layout_1 = require("./entity-map-layout");
exports.EntityListRouteDefaultProps = {
  loadingMessage: 'Loading. Please wait...'
};
// -------- Styles -------->
var EntityListLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var EntityNetworkLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var EntityMapLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TabsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  EntityListLayout: (0, styled_components_1.default)(entity_list_layout_1.EntityListLayout)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), EntityListLayoutStyles),
  EntityNetworkLayout: (0, styled_components_1.default)(entity_network_layout_1.EntityNetworkLayout)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), EntityNetworkLayoutStyles),
  EntityMapLayout: (0, styled_components_1.default)(entity_map_layout_1.EntityMapLayout)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), EntityMapLayoutStyles),
  Tabs: (0, styled_components_1.default)(entity_list_tabs_1.EntityListTabs)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), TabsStyles)
};
var entityApplyVisibilityState = function (state) {
  var safeState = state || {};
  return __assign(__assign({}, safeState), {
    filter: __assign(__assign({}, state.filter || {}), {
      visibility: {
        isNullOrIn: ["visible"]
      }
    })
  });
};
var EntityListRouteComponent = function (props) {
  var definition = props.definition;
  var entityTypeName = definition.name;
  var paramState = props['*'];
  var t = (0, use_lang_1.useLang)();
  var list = definition.list;
  var applyVisibilityState = list.applyVisibilityState;
  // console.log("LIST DEFINITION IS", definition);
  // find the appSection child, which is a list on this entity
  var applyFilterState = applyVisibilityState && !(0, current_user_can_1.currentUserCan)('read:hidden') ? entityApplyVisibilityState : list.applyFilterState || props.applyFilterState;
  if (!definition) {
    throw new Error("Entity List cannot be created. Missing entity configuration.");
  }
  var isList = !(0, lodash_1.includes)(['network', 'map'], paramState);
  var isNetwork = paramState === 'network';
  var isMap = paramState === 'map';
  var isConversations = paramState === 'conversations';
  return React.createElement(app_screen_layout_1.AppScreenLayout, {
    overflow: isMap ? 'hidden' : 'auto',
    header: React.createElement(My.Tabs, {
      params: paramState,
      entityTypeName: entityTypeName
    })
  }, React.createElement(seo_1.Seo, {
    includeOpenGraph: true,
    title: definition.pluralLabel
  }), isNetwork && React.createElement(My.EntityNetworkLayout, {
    entityTypeName: entityTypeName
  }), isMap && React.createElement(My.EntityMapLayout, {
    entityTypeName: entityTypeName
  }), isList && React.createElement(My.EntityListLayout, {
    paramState: paramState,
    applyFilterState: applyFilterState,
    entityTypeName: entityTypeName
  }));
};
exports.EntityListRouteComponent = EntityListRouteComponent;
exports.EntityListRouteComponent.defaultProps = exports.EntityListRouteDefaultProps;
exports.EntityListRoute = React.memo(exports.EntityListRouteComponent);
var entityListRouteComponent = function (definition, withProps) {
  if (withProps === void 0) {
    withProps = {};
  }
  return function (props) {
    return React.createElement(exports.EntityListRoute, __assign({
      definition: definition
    }, props, withProps));
  };
};
exports.entityListRouteComponent = entityListRouteComponent;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;